import React, { useContext } from "react"
import { Contest } from "@components/contest"
import { Context as AdminContext } from "@components/ui-builder/admin-context"

const TeaserContest = ({ contest_id, ...props }) => {
  const isAdmin = useContext(AdminContext)
  if (!contest_id) {
    return isAdmin ? (
      <div
        className="panel panel-danger"
        style={{ position: "relative", zIndex: 1 }}
      >
        <div className="panel-body text-center">
          Hier sollte ein Gewinnspiel des Tages gezeigt werden, leider wurde
          aber für heute keines gefunden. <br />
          In der Nutzeransicht ist dieses Element unsichtbar.
        </div>
      </div>
    ) : null
  } else {
    return <Contest className="content-feed-contest" {...props} />
  }
}

export default TeaserContest
